import Toaster from "components/toaster/Toaster";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./i18n";
import "./index.css";
import { store } from "./reduxFiles/store";
import "./services/tabSessionManager";

export const PUBLIC_URL = process.env.PUBLIC_URL || "/";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <Provider store={store}>
    <BrowserRouter basename={PUBLIC_URL}>
      <Toaster />
      <App />
    </BrowserRouter>
  </Provider>
);
